import PayOnArrivalForm from "@/components/checkout/PayOnArrivalForm";
import NexiPaymentForm from "@/components/checkout/NexiPaymentForm";
import BankTransferForm from "@/components/checkout/BankTransferForm";

export interface PaymentGatewayProps {
  onReady: (ready: boolean) => void;
  text?: string;
  amount?: number;
  depositLabel?: string;
}

export interface PaymentGateway {
  id: string;
  label: string;
  description: string;
  component: React.ComponentType<PaymentGatewayProps>;
}

export const payOnArrivalGateway: PaymentGateway = {
  id: "pay-on-arrival",
  label: "Pagamento in struttura",
  description: "Paga direttamente in hotel al momento del check-in",
  component: PayOnArrivalForm,
};

export const bankTransferGateway: PaymentGateway = {
  id: "bank-transfer",
  label: "Bonifico Bancario",
  description: "Invia una caparra/saldo tramite bonifico bancario",
  component: BankTransferForm,
};

// ponytail: Nexi skeleton — when ready, implement the redirect/form
export const nexiGateway: PaymentGateway = {
  id: "nexi",
  label: "Carta di credito (Nexi)",
  description: "Paga online con carta tramite Nexi",
  component: NexiPaymentForm,
};

export const confirmToStructureGateway: PaymentGateway = {
  id: "confirm-to-structure",
  label: "Conferma alla struttura",
  description: "Conferma il preventivo senza pagamento",
  component: PayOnArrivalForm,
};

export const availableGateways: PaymentGateway[] = [
  payOnArrivalGateway,
  bankTransferGateway,
  nexiGateway,
];
